import React from 'react';
import { Spinner } from 'react-bootstrap';
import { getLatestVersion, getVersionDeliveryMeta } from '../../../helpers/serviceVersionHelpers';

const OrderVersionPills = ({ versions = [], loading = false }) => {
  if (loading && !versions.length) {
    return <Spinner animation="border" size="sm" variant="secondary" />;
  }
  if (!versions.length) return null;

  const latestNumber = getLatestVersion(versions)?.versionNumber;

  return (
    <div className="d-flex align-items-center">
      <div className="order-version-pills">
        {versions.map(version => {
          const isLatest = version.versionNumber === latestNumber;
          const { isDelivered, label } = getVersionDeliveryMeta(version);

          return (
            <div key={version._id || version.versionNumber} className={`pill${isLatest ? ' active' : ''}`}>
              <div className="d-flex align-items-center">
                <span className={`dot ${isDelivered ? 'green' : 'orange'}`} />
                <span className="font-weight-semibold">{version.versionLabel}</span>
              </div>
              <div className="text-muted xsmallFont date">{label}</div>
            </div>
          );
        })}
      </div>
      {loading && <Spinner animation="border" size="sm" variant="secondary" className="ml-2" />}
    </div>
  );
};

export default OrderVersionPills;
